export * from './blobs'
export * from './cssStrings'

export const SOME_DIFF_CONTEXT_LINES = 2
